export default __webpack_public_path__ + "static/media/shouj.baaf9e9f.png";